module.exports = __webpack_public_path__ + "static/media/colg.be6ca29b.png";